import React from 'react'
import { ErrorBoundary } from '@/app/providers/error-boundary'

// PageWrapper provides error boundary protection for each page
// NOTE: Suspense is intentionally NOT included here - it's handled by MainLayout
// to prevent sidebar flashing during navigation. The single Suspense boundary
// in MainLayout keeps the previous page content visible while loading.
export const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>
    {children}
  </ErrorBoundary>
)